import { render, staticRenderFns } from "./handleContract.vue?vue&type=template&id=0454d7ea"
import script from "./handleContract.vue?vue&type=script&lang=js"
export * from "./handleContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports